import { random } from "core/math";
import { dt } from "lib/loop";

export const shaker = {
  _shakeTime: -1,
  _intensity: 0,
  _offsetX: 0,
  _offsetY: 0,

  perform(intensity: number, duration: number): void {
    this._intensity = intensity;
    this._shakeTime = duration;
  },

  update(): void {
    if (this._shakeTime > 0) {
      this._shakeTime -= dt;
      this._offsetX = (this._intensity * (random() * 2 - 1) * 60) | 0;
      this._offsetY = (this._intensity * (random() * 2 - 1) * 60) | 0;
    } else if (this._shakeTime <= 0 && this._shakeTime !== -1) {
      this._shakeTime = -1;
      this._offsetX = 0;
      this._offsetY = 0;
    }
  },
};
